// extracted by css-extract-rspack-plugin
export default {"MarkdownViewerHelpText":"IssueMarkdownViewer-module__MarkdownViewerHelpText__rK7vqiY"};